export const parseCategories = data => {
  const r = Object.keys(data).map(key => ({
    name: key,
    value: data[key].amount,
  }));
  r.sort((x, y) => x.value - y.value);
  return r;
};

export const parseLikes = data => {
  const r = {};
  Object.keys(data).forEach(category => {
    const likesEndpointFormat = data[category].details;
    const likesBarchartFormat = Object.keys(likesEndpointFormat).map(likeName => ({
      name: likeName,
      value: likesEndpointFormat[likeName],
    }));
    likesBarchartFormat.sort((x, y) => x.value - y.value);
    r[category] = likesBarchartFormat;
  });
  return r;
};
